import { Type } from '@deqo/foundation';
import { Component } from '../../../concepts/objects';
import { Sticky } from '../paper/Sticky';
import { Token } from '../tokens/Token';

export type TrayMode = 'none' | 'stickies' | 'emotions' | 'tShirtSizes' | 'storyPoints' | 'participants' | 'custom';

export type TrayModeOption = {
    label: string,
    mode: TrayMode,
};

const all: TrayModeOption[] = [
    { label: 'Stickies', mode: 'stickies' },
    { label: 'Emotions', mode: 'emotions' },
    { label: 'T-Shirt Sizes', mode: 'tShirtSizes' },
    { label: 'Story Points', mode: 'storyPoints' },
    { label: 'Participants', mode: 'participants' },
    { label: 'Custom', mode: 'custom' },
];

export const TrayModeOption = {
    all,
    get(mode: TrayMode) {
        return all.find(x => x.mode === mode);
    }
};

export type TrayModeContent = ({ type: Type<Component> } & Record<string, any>)[];

export const TrayModeContent: Record<string, TrayModeContent> = {

    stickies: [
        {
            type: Sticky,
            background: '#2196f3',
        },
        {
            type: Sticky,
            background: '#ffc107',
        },
        {
            type: Sticky,
            background: '#4caf50',
        },
        {
            type: Sticky,
            background: '#f44336',
        }
    ],

    emotions: [
        {
            type: Token,
            value: ':D',
            background: '#4caf50'
        },
        {
            type: Token,
            value: ':)',
            background: '#8bc34a'
        },
        {
            type: Token,
            value: ':|',
            background: '#ff9800'
        },
        {
            type: Token,
            value: ':(',
            background: '#ff5722'
        },
        {
            type: Token,
            value: '>:(',
            background: '#f44336'
        }
    ],

    tShirtSizes: [
        {
            type: Token,
            value: 'XS',
            background: '#03a9f4'
        },
        {
            type: Token,
            value: 'S',
            background: '#00bcd4'
        },
        {
            type: Token,
            value: 'M',
            background: '#009688'
        },
        {
            type: Token,
            value: 'L',
            background: '#3f51b5'
        },
        {
            type: Token,
            value: 'XL',
            background: '#673ab7'
        },
        {
            type: Token,
            value: 'XXL',
            background: '#9c27b0'
        }
    ],

    storyPoints: [
        {
            type: Token,
            value: '0',
            background: '#03a9f4'
        },
        {
            type: Token,
            value: '1',
            background: '#2196f3'
        },
        {
            type: Token,
            value: '2',
            background: '#3f51b5'
        },
        {
            type: Token,
            value: '3',
            background: '#673ab7'
        },
        {
            type: Token,
            value: '5',
            background: '#9c27b0'
        },
        {
            type: Token,
            value: '8',
            background: '#009688'
        },
        {
            type: Token,
            value: '13',
            background: '#00bcd4'
        },
        {
            type: Token,
            value: '20',
            background: '#cddc39'
        },
        {
            type: Token,
            value: '40',
            background: '#ffc107'
        },
        {
            type: Token,
            value: '100',
            background: '#f44336'
        }
    ]

};
